var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "16",
        viewBox: "0 0 15 16",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_142_3177)" } }, [
        _c("path", {
          attrs: {
            d: "M11.91 3.34259H3.31138C2.63297 3.34259 2.08301 3.89255 2.08301 4.57097V13.1696C2.08301 13.848 2.63297 14.398 3.31138 14.398H11.91C12.5884 14.398 13.1384 13.848 13.1384 13.1696V4.57097C13.1384 3.89255 12.5884 3.34259 11.91 3.34259Z",
            stroke: "#717986",
            "stroke-width": "1.38192",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M2.08301 7.02771H13.1384",
            stroke: "#717986",
            "stroke-width": "1.38192",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M10.0676 2.1142V4.57095",
            stroke: "#717986",
            "stroke-width": "1.38192",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("path", {
          attrs: {
            d: "M5.15405 2.1142V4.57095",
            stroke: "#717986",
            "stroke-width": "1.38192",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_142_3177" } }, [
          _c("rect", {
            attrs: {
              width: "14.7405",
              height: "14.7405",
              fill: "white",
              transform: "translate(0.240479 0.885803)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }